const state = {
  results: {
    data: [],
  },
  filters: {
    academicyears: [],
    servicestatus: [],
    servicetype: [],
    approvedPrinting: [],
  },
  tableConfig: {
    totalRecords: 0,
    serverParams: {
      columnFilters: {},
      sort: {
        field: '',
        type: '',
      },
      page: 1,
      perPage: 15,
    },
    columns: [],
  },
  currentFilters: {},
  reasons: {},
};

export default state;
